module.exports = __webpack_public_path__ + "img/search.3b60206a.svg";